

















































































import { Vue, Component, Prop } from "vue-property-decorator";
import { formatShippingDate } from "@/utils/shipping-date";

@Component
export default class ReportInfo extends Vue {
  @Prop() readonly report!: any;

  public formatShippingDate(date: Date) {
    return formatShippingDate(date);
  }
}
